interface SolutionsDescriptionProps {
 description: string
}

export function SolutionsDescriptionMobile({
 description
}: SolutionsDescriptionProps) {
 return (
  <p className="font-['rns-milesregular'] font-normal text-base text-[var(--text-main)]">
   {description}
  </p>
 )
}
